module.exports = __webpack_public_path__ + "media/markers/marker-transparent-red-9ed65e91.svg";